import { render, staticRenderFns } from "./SLGATransactionReport.vue?vue&type=template&id=1da83358&"
import script from "./SLGATransactionReport.vue?vue&type=script&lang=js&"
export * from "./SLGATransactionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports